import { CircularProgress, Grid } from "@mui/material";
import DefaultTextInput from "components/common/DefaultTextInput/DefaultTextInput";
import React, { useEffect, useState } from "react";
import EditableSelect from "../EditableSelect/EditableSelect";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { getToken } from "auth/authenticate";
import axios from "axios";
import ErrorDisplay from "components/common/ErrorDisplay/ErrorDisplay";
const districts = [
  "Colombo",
  "Gampaha",
  "Kalutara",
  "Kandy",
  "Matale",
  "Nuwara Eliya",
  "Galle",
  "Matara",
  "Hambantota",
  "Jaffna",
  "Kilinochchi",
  "Mannar",
  "Vavuniya",
  "Mullaitivu",
  "Batticaloa",
  "Ampara",
  "Trincomalee",
  "Kurunegala",
  "Puttalam",
  "Anuradhapura",
  "Polonnaruwa",
  "Badulla",
  "Moneragala",
  "Ratnapura",
  "Kegalle",
];
export default function Index({
  handleAddPatientDialogClose = () => {},
  data,
  handleRefresh = () => {},
}) {
  const [name, setName] = useState("");
  const [dob, SetDob] = useState("");
  const [gender, setGender] = useState("MALE");
  const [email, setEmail] = useState("");
  const [district, setDistrict] = useState("COLOMBO");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [isEditable, setIsEditable] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    if (data) {
      setName(data?.name);
      SetDob(data?.dob);
      setGender(data?.gender);
      setEmail(data?.User?.email);
      setDistrict(data?.district);
      setPhone(data?.User?.phoneNumber);
      setAddress(data?.address);
      setPassword("123456");
      setIsUpdate(true);
    }
  }, [data]);

  const validate = async () => {
    const errors = {};
    if (!name) {
      errors.name = "Name is required";
    }
    if (!email) {
      errors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
      errors.email = "Invalid email address";
    }
    const regex =
      /^(0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;
    if (!regex.exec(phone)) {
      errors.phone = "Incorrect phone number (eg- 071XXXXXXX)";
    }
    if (!dob) {
      errors.dob = "Date of Birth is required";
    }else if(new Date(dob)>=new Date()){
      errors.dob = "Invalid Date of Birth";
    }
    if (!address) {
      errors.address = "Address is required";
    }

    if (!password) {
      errors.password = "Password is required";
    }
    // if (!district) {
    //   errors.district = "District is required";
    // }
    if (!gender) {
      errors.gender = "Gender is required";
    }
    setErrors(errors);
    return errors;
  };

  const onSubmit = async () => {
    setLoading(true);
    if (Object.keys(await validate()).length !== 0) {
      setLoading(false);
      return;
    }
    if (isUpdate) {
      const payload = {
        patientId: data?.patientId,
        email: email,
        phoneNumber: phone,
        name: name,
        gender: gender,
        district: district,
        address: address,
        dob: dob,
        // password: password,
      };
      let config = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      await axios
        .put(
          `${process.env.REACT_APP_BACKEND_URL}user/patient/update-patient`,
          payload,
          config
        )
        .then((response) => {
          alert("Successfully Updated");
          handleAddPatientDialogClose();
          handleRefresh();
        })
        .catch((error) => {
          const errors = {};
          errors.backend = error.response.data.message;
          setErrors(errors);
          // alert("Something went wrong Please recheck your inputs!");
        });
    } else {
      const payload = {
        email: email,
        phoneNumber: phone,
        name: name,
        gender: gender,
        district: district,
        address: address,
        dob: dob,
        password: password,
      };
      let config = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
      await axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}user/patient/add-patient`,
          payload,
          config
        )
        .then((response) => {
          alert("Successfully Added");
          handleAddPatientDialogClose();
          handleRefresh();
        })
        .catch((error) => {
          // console.log(error.response.data.message);
          const errors = {};
          errors.backend = error.response.data.message;
          setErrors(errors);
          // alert("Something went wrong Please recheck your inputs!");
        });
    }
    setLoading(false);
  };

  //   if (loading) {
  //     return (
  //       <center style={{ marginTop: 100 }}>
  //         <CircularProgress />
  //       </center>
  //     );
  //   }

  return (
    <>
      {loading ? (
        <center style={{ marginTop: 100, marginBottom: 100 }}>
          <CircularProgress />
        </center>
      ) : (
        <>
          <DialogContent className="selectTimeDialogContent">
            <h3 style={{ textAlign: "center" }}>
              {isUpdate ? "Update Guardian Profile" : "Add Guardian Profile"}
            </h3>
            <Grid container className="personalInfoGrid1">
              <Grid item lg={12} md={12} xs={12}>
                <Grid container>
                  <Grid item lg={12} md={12} xs={12}>
                    <div className="infoCol1">
                      {/* Column 1 */}

                      <Grid item lg={6} md={6} xs={12}>
                        <div className="info2">
                          <DefaultTextInput
                            title="Name"
                            editableText={true}
                            value={name}
                            placeholder={"Name"}
                            onChangeValue={(v) => {
                              setName(v.target.value);
                            }}
                            onEditClick={(e) => e && setIsEditable(true)}
                          />
                        </div>
                        <div className="info2">
                          <DefaultTextInput
                            type="date"
                            title="Date of Birth"
                            editableText={true}
                            value={dob?.split("T")[0]}
                            placeholder={"Email"}
                            onChangeValue={(v) => {
                              SetDob(v.target.value);
                            }}
                            onEditClick={(e) => e && setIsEditable(true)}
                          />
                        </div>
                        <div className="info2">
                          <DefaultTextInput
                            title="Phone"
                            editableText={true}
                            value={phone}
                            placeholder={"Phone"}
                            onChangeValue={(v) => {
                              setPhone(v.target.value);
                            }}
                            onEditClick={(e) => e && setIsEditable(true)}
                          />
                        </div>
                        <div className=" info2">
                          <EditableSelect
                            selected={district}
                            options={districts}
                            title="District"
                            editableText={true}
                            value={district}
                            placeholder="District"
                            onEditClick={(e) => e && setIsEditable(true)}
                            onChangeValue={(v) => {
                              setDistrict(v.target.value);
                            }}
                          />
                        </div>
                      </Grid>

                      {/* Column 2 */}

                      <Grid item lg={6} md={6} xs={12}>
                        <div className=" info2">
                          <DefaultTextInput
                            title="Email"
                            editableText={true}
                            value={email}
                            placeholder={"Email"}
                            onChangeValue={(v) => {
                              setEmail(v.target.value);
                            }}
                            onEditClick={(e) => e && setIsEditable(true)}
                          />
                        </div>
                        <div className=" selectInfo info2">
                          <EditableSelect
                            selected={gender}
                            options={["Male", "Female"]}
                            title="Gender"
                            editableText={true}
                            value={gender}
                            placeholder="Gender"
                            onEditClick={(e) => e && setIsEditable(true)}
                            onChangeValue={(v) => {
                              setGender(v.target.value);
                            }}
                          />
                        </div>
                        <div className="info2">
                          <DefaultTextInput
                            title="Address"
                            editableText={true}
                            value={address}
                            placeholder={"Address"}
                            onChangeValue={(v) => {
                              setAddress(v.target.value);
                            }}
                            onEditClick={(e) => e && setIsEditable(true)}
                          />
                        </div>
                        {!isUpdate && (
                          <div className="info2">
                            <DefaultTextInput
                              title="Password"
                              type="password"
                              editableText={true}
                              value={password}
                              placeholder={"Password"}
                              onChangeValue={(v) => {
                                setPassword(v.target.value);
                              }}
                              onEditClick={(e) => e && setIsEditable(true)}
                            />
                          </div>
                        )}
                      </Grid>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <ErrorDisplay errors={errors} />
          </DialogContent>
          <DialogActions className="editDialogAction">
            <Button
              autoFocus
              className="editDialogDoneBtn"
              disabled={!isEditable}
              onClick={onSubmit}
            >
              {isUpdate ? "Update Guardian" : "Add Guardian"}
            </Button>
            <Button
              variant="outlined"
              className="cancelBtn"
              onClick={handleAddPatientDialogClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </>
      )}
    </>
  );
}
